import * as React from 'react';
import * as _ from 'lodash';
export default function () {
    return React.createElement('h2', { 'className': 'section-title' }, this.props.children);
}